/*jshint esversion: 6 */

window.addEventListener('load', () => {
	//Center content on active or middle
	const activeLink = el.querySelector(":scope .active");
	if (activeLink) {
		console.log(activeLink);
		activeLink.scrollIntoView({
			  behavior: 'auto',
			  block: 'center',
			  inline: 'center'
		  });
	} else {
		const liElements = el.querySelectorAll('.tag');
		const middleIndex = Math.floor(liElements.length / 2);
		const middleElement = liElements[middleIndex];

		// Scroll the middle element into view and center it
		middleElement.scrollIntoView({
		  behavior: 'auto',
		  block: 'center',
		  inline: 'center'
		});
	}
});


//Navigation
let el = document.querySelector("#tagList");
let x = 0, left = 0;
let dragging = false;
let navInterval;

const leftNav = document.querySelector("#leftNavIcon");
const rightNav = document.querySelector("#rightNavIcon");
const navSpeed = 2;

const startNavigation = (side) => {
  navInterval = setInterval(() => {
	el.scrollLeft += navSpeed * (side ? 1 : -1);
  }, 1);
};

const stopNavigation = () => {
  clearInterval(navInterval);
};

const draggingFunction = (e) => {
	dragging = true;
	el.scrollLeft = left - e.pageX + x;
};

leftNav.addEventListener('mousedown', () => {
  startNavigation(false);
});

rightNav.addEventListener('mousedown', () => {
  startNavigation(true);
});

leftNav.addEventListener('touchstart', () => {
  startNavigation(false);
});

rightNav.addEventListener('touchstart', () => {
  startNavigation(true);
});

leftNav.addEventListener('mouseup', stopNavigation);
leftNav.addEventListener('touchend', stopNavigation);
leftNav.addEventListener('mouseout', stopNavigation);
rightNav.addEventListener('mouseup', stopNavigation);
rightNav.addEventListener('touchend', stopNavigation);
rightNav.addEventListener('mouseout', stopNavigation);

//On mouse down, start dragging
el.addEventListener('mousedown', (e) => {
	e.preventDefault();
	x = e.pageX;
	left = el.scrollLeft;
	document.addEventListener('mousemove', draggingFunction);
});

//On mouse up stop dragging
document.addEventListener('mouseup', (e) => {
	document.removeEventListener("mousemove", draggingFunction);
	stopNavigation();

	//Remove flag only if we are releasing the mouse out of links
	if (e.target.nodeName.toLowerCase() != 'a')
		dragging = false;
});

//Prevent click (mousedown + mouseup) when dragging
el.addEventListener('click', (e) => {
	if (dragging) {
		e.preventDefault();

		//End dragging on click (mouseup over link)
		dragging = false;
	}
});